export default __webpack_public_path__ + "static/media/logo1.2ecb8be9.png";